module.exports = "img/flags/VC.9434d08.png";